import {PollRobotTemplate} from './PollRobotTemplate.js';

export class VeejayTargetDisplay {
	constructor(parent, js) {
		this.parent = parent;
		this.js = js;
		[this.el, this.$] = PollRobotTemplate(`VeejayTargetDisplay`);
		this.el.innerHTML = js.Data.url;
		parent.appendChild(this.el);
	}
}